import Layout from "src/layout";
import styled, { css } from "styled-components";
import { useBoundStore } from "src/store";
import { ReactNode, useEffect, useRef, useState } from "react";
import { theme } from "src/styles/theme";
import ReviewQcastStudio from "./PublishQCastStudio";
import Loader from "src/components/Loader";
import { useMediaQuery } from "react-responsive";

const RespondContainer = styled.div<{snapshot?: string}>`
    width: 100%;
    min-height: 100%;
    overflow-y: auto;
    color: white;
    display: flex;
    flex-direction: column;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    background: #E9E7E9;
    background-image: ${({ snapshot }) => `url(${snapshot})`};
    background-size: cover;
    background-position: center;
    position: relative;
    backdrop-filter: blur(120px);
`;

const Publish = () => {
    const [videos, setVideos] = useState<{url: string, title: string}[]>([])
    const { activityLoader, questions, dbResponse, updateResponderDetails, clearQcasts } = useBoundStore();
    const [currentVideoIndex, setCurrentVideoIndex] = useState<number>(0);

    const isMobile = useMediaQuery({ maxWidth: theme.breakpoints.mobile });

    const [snapshot, setSnapshot] = useState<string | null>(null);
    
    
    const handleCancel = () => {
    };
    
    const handleRecord = () => {
    };
    
    const handleVideoNavigation = (index: number) => {
        setCurrentVideoIndex(prev=>prev + index);
    }

    const handleSnapshot =(imageData: string) => {
        setSnapshot(imageData)
    }

    
    useEffect(()=>{
        const cleanStore=async()=>{
            await clearQcasts();
        }
        cleanStore();
    }, [])

    
    return (
        <Layout scroll={isMobile}>
            {activityLoader && <Loader />}
            <RespondContainer snapshot={snapshot}>
                <ReviewQcastStudio avaterSrc={questions.coverPhoto} qcastId={questions.qcastId} userId={questions.userId} interviewId={dbResponse?.interviewId} onUpdate={updateResponderDetails}  />
            </RespondContainer>
        </Layout>
    )
}

export default Publish;